import { ProductRecentlyViewedActionTypes } from '../../../enums/ActionEnums';
export const ProductRecentlyViewedActions = {
    getRecentlyViewedProducts: () => ({
        type: ProductRecentlyViewedActionTypes.GET,
    }),
    fetchProducts: (payload) => ({
        type: ProductRecentlyViewedActionTypes.FETCH,
        payload,
    }),
    eraseProducts: () => ({
        type: ProductRecentlyViewedActionTypes.ERASE,
    }),
    getDeliveryPromise: (payload) => ({
        type: ProductRecentlyViewedActionTypes.GET_DELIVERY_PROMISE,
        payload,
    }),
    setDeliveryPromise: (payload) => ({
        type: ProductRecentlyViewedActionTypes.SET_DELIVERY_PROMISE,
        payload,
    }),
};
